// extracted by mini-css-extract-plugin
module.exports = {"secondary":"z_fs","secondary_negative":"z_ft"};